import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import styles from './Common.module.css'
import { CSSTransition } from 'react-transition-group'
import './Validation.css'
import { faCheckDouble } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PatientCareCenterNoteValidationDetails } from './Details';

class PatientCareCenterNoteValidation extends React.Component {

    validationClicked() {
        this.props.toggleVisibility({ noteId: this.props.noteId, visible: !this.props.visible })
    }

    render() {
        return (
            <span>
                <CSSTransition
                    key={'Validation' + this.props.noteId}
                    in={this.props.visible}
                    timeout={400}
                    classNames='slideout'
                    unmountOnExit
                >
                    <div className={styles.validation_wrapper}>
                        <span className={styles.header_wrapper} onClick={() => this.validationClicked()}>
                            <FontAwesomeIcon icon={faCheckDouble} color="#006699" />
                            <label className={styles.header}>Note Validation Assistant</label>
                        </span>
                        <PatientCareCenterNoteValidationDetails />
                    </div>
                </CSSTransition>
                {!this.props.visible &&
                    <div className={styles.validation_wrapper_hidden} onClick={() => this.validationClicked()}>
                        <span className={styles.header_wrapper}>
                            <FontAwesomeIcon icon={faCheckDouble} color="#006699" />
                        </span>
                    </div>
                }
            </span>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        toggleVisibility: bindActionCreators(noteActions.toggleValidationVisibility, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let visible = state.ui.notes[noteId].validationVisible;

    return {
        noteId: noteId,
        visible: visible
    };
}

const connectedPatientCareCenterNoteValidation = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteValidation);
export { connectedPatientCareCenterNoteValidation as PatientCareCenterNoteValidation };

